import { PdfReportsService } from './apiclient/api/pdfReports.service';
import { ReportsService } from './apiclient/api/reports.service';

import { UserSessionService } from './UserSession/user-session.service';
import { UserService, CompanyService, ImagesService, FramelinksService, CustomformsService, SystemService } from './apiclient';
/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { BrowserModule } from '@angular/platform-browser';
import { LOCALE_ID } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { CoreModule } from './@core/core.module';
import { ThemeModule } from './@theme/theme.module';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import {MatDatepickerModule} from '@angular/material/datepicker';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import {
  NbChatModule,
  NbDatepickerModule,
  NbDialogModule,
  NbMenuModule,
  NbSidebarModule,
  NbTimepickerModule,
  NbToastrModule,
  NbWindowModule,
} from '@nebular/theme';
import { SmartRuralAuthModule } from './smart-rural-auth/smart-rural-auth.module';
import { AuthGuard } from './auth-guard.service';
import { ExcelExporterService } from './excel-exporter.service';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import localeEs from '@angular/common/locales/es';
import { registerLocaleData } from '@angular/common';
import { CustomEntityService } from './apiclient/api/customEntity.service';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { LoginInterceptor } from './login.interceptor';

registerLocaleData(localeEs);

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    SmartRuralAuthModule,
    ThemeModule.forRoot(),
    MatDatepickerModule,
    MatMomentDateModule,
    MatFormFieldModule,
    MatInputModule,
    NbSidebarModule.forRoot(),
    NbMenuModule.forRoot(),
    NbDatepickerModule.forRoot(),
    NbTimepickerModule.forRoot(),
    NbDialogModule.forRoot(),
    NbWindowModule.forRoot(),
    NbToastrModule.forRoot(),
    NbChatModule.forRoot({
      messageGoogleMapKey: 'AIzaSyA_wNuCzia92MAmdLRzmqitRGvCF7wCZPY',
    }),
    CoreModule.forRoot(),
    AngularMultiSelectModule,
    NgMultiSelectDropDownModule.forRoot()
  ],
  providers: [
    AuthGuard , UserService, UserSessionService,CompanyService,ImagesService,FramelinksService,SystemService,
    ReportsService,
    ExcelExporterService,
    PdfReportsService,
     CustomformsService,CustomEntityService,
     { provide: LOCALE_ID, useValue: 'es' },
     { provide: HTTP_INTERCEPTORS, useClass: LoginInterceptor, multi: true }
  ],
  bootstrap: [AppComponent],
  exports :[    MatFormFieldModule,
    MatInputModule,AngularMultiSelectModule],
})
export class AppModule {
}
